<template>
  <div id="layout-container">
    <div id="left">
      <!-- <div id="topLeft">
        门店运营
      </div> -->
      <!-- 左上角返回工作台按钮 -->
      <div class="back-workbench-btn" @click="goToWorkbench">
        <span class="icon">←</span>
        <span class="text">返回工作台</span>
      </div>
      <div id="inner">
        <!-- <button class="back-btn" @click="goBack">← 返回</button> -->
        <el-menu
          v-bind:uniqueOpened="true"
          :default-active="retailinkMenuHighLight"
          v-on:select="select"
          background-color="#272727"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <div :key="menu.url + '***' + menu.menuCode" v-for="menu in retailinkMenus">
            <el-submenu v-bind:index="menu.url + '***' + menu.menuCode" v-if="menu.hasSubMenu">
              <template slot="title">
                <i :class="menu.icon"></i>
                <span>{{ menu.menuName }}</span>
              </template>
              <el-menu-item-group
                :key="subMenu.url + '***' + subMenu.menuCode"
                v-for="subMenu in menu.subMenuList"
              >
                <el-menu-item v-bind:index="subMenu.url + '***' + subMenu.menuCode">{{
                    subMenu.menuName
                  }}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-menu-item v-bind:index="menu.url + '***' + menu.menuCode" v-else>
              <i v-bind:class="menu.icon"></i>

              <!--          <span>{{ menu.menuCode }}</span>-->
              <span slot="title">{{ menu.menuName }}</span>
            </el-menu-item>
          </div>
        </el-menu>

      </div>
    </div>
    <div id="right">
      <div id="topRight">
        <div id="title">{{ retailinkMenuTitle }}</div>
        <div id="login-user">
          <i class="el-icon-user"></i>{{ name }}
          <el-button type="text" size="small" @click="loginout">
            <i class="el-icon-warning-outline"></i>
            {{ $t('login.logout')}}
          </el-button>
        </div>
      </div>
      <div id="main">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  name: 'layout-admin',
  data: function () {
    return {
      retailinkMenus: [],
      menuMap: {},
      menuTitleMap: JSON.parse(localStorage.getItem("retailinkMenuTitleMap"))
    }
  },
  mounted: function () {
    this.initMenu()
  },
  computed: {
    retailinkMenuTitle: function () {
      return this.$store.getters.retailinkMenuTitle;
    },
    name: function () {
      return localStorage.getItem("userName")
    },
    roleCode: function () {
      return this.$store.getters.roleCode;
    },
    retailinkMenuHighLight() {
      console.log('highlight', this.$store.getters.retailinkMenuHighLight)
      return this.$store.getters.retailinkMenuHighLight;
    }
  },
  // watch:{
  // $route: function(val){
  // this.$set(this,'current',{path:val.path,title:this.menuMap[val.path]})
  // }
  // },
  methods: {
    initMenu() {
      let retailinkMenus = JSON.parse(localStorage.getItem("retailinkMenus"));
      this.retailinkMenus = retailinkMenus;
      console.log('this.retailinkMenus', this.retailinkMenus)
      // this.retailinkMenus.push({
      //   menuId: "offlineCourse",
      //   menuName: "线下课程管理",
      //   icon: "",
      //   url: "",
      //   hasSubMenu: true,
      //   subMenuList: [
      //     {
      //       menuId: "offlineCourseCreate",
      //       menuName: "创建新课程",
      //       icon: "",
      //       url: "offlineCourseCreate",
      //       hasSubMenu: false,
      //       subMenuList: [],
      //     },
      //     {
      //       menuId: "offlineCourseOn",
      //       menuName: "已上架课程",
      //       icon: "",
      //       url: "offlineCourseOn",
      //       hasSubMenu: false,
      //       subMenuList: [],
      //     },
      //     {
      //       menuId: "offlineCourseOff",
      //       menuName: "已下架课程",
      //       icon: "",
      //       url: "offlineCourseOff",
      //       hasSubMenu: false,
      //       subMenuList: [],
      //     },
      //     {
      //       menuId: "offlineCoursePermission",
      //       menuName: "权限设置",
      //       icon: "",
      //       url: "offlineCoursePermission",
      //       hasSubMenu: false,
      //       subMenuList: [],
      //     },
      //   ],
      // });
      // this.select("competitionManage")
    },


    goToWorkbench() {
      window.location.replace("https://uat.lingshutong.cn/#/desktop")
    },


    select: function (key) {

      let [menuKey, menuCode] = key.split('***');
      console.log('menuKey', menuKey)
      if(menuKey.indexOf("https") != -1) {
        window.open(menuKey)
        return false;
      }
      else {
        this.$router.push({ path: `${menuKey}`, query: { menuCode: menuCode, ut: Date.now() } });
        // 重新设置标题
        console.log('this.menuTitleMap[menuKey]', this.menuTitleMap[menuKey])
        this.$store.commit("setMenuTitle", this.menuTitleMap[menuKey]);
      }

      this.$store.commit("setMenuHighLight", key);
    },
    loginout: function () {
      this.$store.commit("setToken", "");
      this.$store.commit("setAccount", "");
      Cookies.set("token", "");
      Cookies.set("account", "");
      Cookies.set("retailink-roleCode", "");
      // todo: 退出登录的时候,清空标题和退出时候的路由
      // this.$store.commit("setMenuTitle", "");
      // this.$store.commit("setMenuHighLight", "");
      // this.$router.push('/login')
      window.location.replace("https://uat.lingshutong.cn/#/login")
    }
  }
}
</script>

<style scoped lang="scss">
#layout-container {

  .back-workbench-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    color: #fff;
    cursor: pointer;
    border-bottom: 1px solid #333; /* 加一条分隔线，和下面的菜单区分开 */
    transition: background 0.2s;
  }
  .back-workbench-btn:hover {
    background: #333;
  }
  .back-workbench-btn .icon {
    font-size: 18px;
  }
  .back-workbench-btn .text {
    font-size: 18px;
  }

  --h: 100%;
  --w: 200px;
  --lw: calc(100% - var(--w));
  --th: 40px;
  --mh: calc(100% - var(--th));
  display: flex;
  height: 100%;

  #left {
    width: var(--w);
    max-height: var(--h);
    background-color: #272727;

    // #topLeft {
    //   width: 100%;
    //   height: var(--th);
    //   color: rgb(255, 208, 75);
    //   text-align: center;
    //   font-size: 24px;
    //   line-height: var(--th);
    //   box-shadow: 0 0 1px 0;
    // }

    #inner {
      width: 100%;
      height: calc(100% - var(--th));
      overflow-y: auto;
      scroll-behavior: smooth;

      &::-webkit-scrollbar {
        width: 3px;
        height: 0px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #c0c4cc;
      }
    }

  }

  #right {
    width: var(--lw);
    height: var(--h);
    background-color: #f1f1f1;

    #topRight {
      width: 100%;
      height: var(--th);
      line-height: var(--th);
      font-size: 16px;
      padding-left: var(--pad);
      padding-right: var(--pad);
      box-shadow: 0 0 1px 0;
      position: relative;

      #title {
        position: absolute;
        left: var(--pad);
      }

      #login-user {
        position: absolute;
        right: var(--pad);
        font-size: 14px;
      }
    }

    #main {
      width: 100%;
      height: var(--mh);
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 3px;
        height: 0px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #c0c4cc;
      }
    }


  }
}</style>



// WEBPACK FOOTER //
// src/layout/layout-admin.vue